import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DashboardService, UserResponse } from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertService } from '@app/core/services/alert.service';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-dashboard-remove-confirm',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    InputDirective,
    TranslatePipe
  ],
  templateUrl: './dashboard-remove-confirm.component.html',
  styleUrl: './dashboard-remove-confirm.component.css'
})
export class DashboardRemoveConfirmComponent implements HasUnsavedChanges {
  protected readonly UserResponse = UserResponse;

  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    serviceRequestIds: new FormControl(null, Validators.required),
    response: new FormControl(null, Validators.required),
  })

  public element?: any;

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly formApiService: FormApiService,
    private readonly alertService: AlertService,
  ) {
    this.alertService.open('modal', 'info','dashboard.remove.info');
  }

  public submit(): void {
    if (!this.element?.serviceRequestId) {
      return;
    }

    this.form.get('serviceRequestIds')?.setValue([this.element.serviceRequestId]);

    this.formApiService.submit(this.form,
      (data) => this.dashboardService.dashboardHandleChangesToProductionObligationPost(data),
      {
        closeModal: true,
        successMessage: 'dashboard.remove.success'
      }
    )
  }


}
